import Grid from '@mui/material/Grid';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import { withBaseComponent } from '../../hoc/withBaseComponent';

/**
 * @param {object} props
 * @param {object} props.blok
 */

const StoryblokLocationCardGroup = ({ blok }) => {
  const { general = { cards: [] } } = blok;
  const { cards } = general;

  return (
    <Grid container spacing={4} {...storyblokEditable(blok)}>
      {cards.map((nestedBlok) => (
        <Grid key={nestedBlok._uid} size={{ lg: 4, md: 6, xs: 12 }}>
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        </Grid>
      ))}
    </Grid>
  );
};

export default withBaseComponent(StoryblokLocationCardGroup);
